import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { errorAlert } from '../../../helpers/alerts';
import { hasSameValues } from '../../../helpers/util';
import { setLoading } from '../../../redux/slices/uiSlice';
import TaskForm from 'components/admin/TaskForm';
import { updateTaskService } from 'services/admin/taskService';
import { updateTask } from 'redux/slices/admin/taskSlice';

const EditTaskScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentTask: current } = useSelector((store) => store.task);
 
  const values = {
    notes: current.notes,
    state: current.state,
  }

  const handlerBack = () => {
    navigate(-1);
  };

  const handlerSubmit = async (data) => {
    dispatch(setLoading(true))
    updateTaskService(current.id, data).then(() => {
      dispatch(updateTask({ id: current.id, data }));
      navigate(-1);
    }).catch((e) => errorAlert(e))
      .finally(() => dispatch(setLoading(false)))
  }

  const validate = (data) => !hasSameValues(values, data)
  return (
    <TaskForm
      title={"Tareas"}
      goBack={handlerBack}
      submit={handlerSubmit}
      validate={validate}
      defaultValues={values}
    />
  )
}

export default EditTaskScreen